"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var isomorphismConstant_1 = require("../../utils/isomorphismConstant");
var website_1 = require("../../utils/website");
var app_1 = require("../../services/page/app");
var query_string_1 = require("query-string");
var searchItem = Object.assign({ currency: "", lang: "", country: "" }, query_string_1.parse(location.search));
var MainStore = (function () {
    function MainStore() {
        var _this = this;
        this.frontPlaygroundModules = [];
        this.frontModules = [];
        this.loadPageError = false;
        this.setState = function (state) {
            for (var _i = 0, _a = Object.keys(state); _i < _a.length; _i++) {
                var key = _a[_i];
                _this[key] = state[key];
            }
        };
        this.getFrontPlayground = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, id, version, _b, slug, result_1, e_1;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = searchItem || {}, id = _a.id, version = _a.version, _b = _a.slug, slug = _b === void 0 ? "" : _b;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4, app_1.GetFrontPlayground({
                                slug: slug,
                                version: version,
                                id: id.trim(),
                                meta: this.meta
                            })];
                    case 2:
                        result_1 = _c.sent();
                        if (result_1 && result_1.modules && result_1.modules.length > 0) {
                            mobx_1.runInAction(function () {
                                _this.frontPlaygroundModules = result_1.modules;
                                _this.frontPlaygroundPage = result_1.page;
                            });
                        }
                        else {
                            mobx_1.runInAction(function () {
                                _this.loadPageError = true;
                            });
                        }
                        return [3, 4];
                    case 3:
                        e_1 = _c.sent();
                        mobx_1.runInAction(function () {
                            _this.loadPageError = true;
                        });
                        return [3, 4];
                    case 4: return [2];
                }
            });
        }); };
        this.getFrontModules = function (moduleIds) { return __awaiter(_this, void 0, void 0, function () {
            var result_2, e_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, app_1.GetFrontModules({
                                moduleId: moduleIds,
                                meta: this.meta
                            })];
                    case 1:
                        result_2 = _a.sent();
                        if (result_2 && result_2.mods) {
                            mobx_1.runInAction("set modules", function () {
                                _this.frontModules = moduleIds.reduce(function (memo, item) {
                                    var module = result_2.mods[item];
                                    if (module) {
                                        return memo.concat(module);
                                    }
                                    return memo;
                                }, []);
                            });
                        }
                        return [3, 3];
                    case 2:
                        e_2 = _a.sent();
                        console.error(e_2);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        this.meta = {
            catalog: isomorphismConstant_1.default.country,
            lang: isomorphismConstant_1.default.language,
            client: website_1.isPC() ? "web" : "mweb",
            priceSymbol: isomorphismConstant_1.default.currency
        };
        this.getFrontPlayground();
        mobx_1.when(function () { return !!_this.frontPlaygroundModules.length; }, function () {
            _this.getFrontModules(_this.frontPlaygroundModules.map(function (i) { return i.id; }));
        });
    }
    Object.defineProperty(MainStore.prototype, "pageId", {
        get: function () {
            return this.frontPlaygroundPage && this.frontPlaygroundPage.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MainStore.prototype, "activityId", {
        get: function () {
            return this.frontPlaygroundPage && this.frontPlaygroundPage.groupId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MainStore.prototype, "backgroundColor", {
        get: function () {
            if (this.frontPlaygroundPage) {
                var ui = this.frontPlaygroundPage.ui;
                if (ui && ui.bgColor) {
                    return ui.bgColor;
                }
            }
            return "initial";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MainStore.prototype, "isPageDisable", {
        get: function () {
            return this.loadPageError || (this.frontPlaygroundPage && this.frontPlaygroundPage.isDisable);
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], MainStore.prototype, "frontPlaygroundPage", void 0);
    __decorate([
        mobx_1.observable
    ], MainStore.prototype, "frontPlaygroundModules", void 0);
    __decorate([
        mobx_1.observable
    ], MainStore.prototype, "frontModules", void 0);
    __decorate([
        mobx_1.observable
    ], MainStore.prototype, "loadPageError", void 0);
    __decorate([
        mobx_1.computed
    ], MainStore.prototype, "pageId", null);
    __decorate([
        mobx_1.computed
    ], MainStore.prototype, "activityId", null);
    __decorate([
        mobx_1.computed
    ], MainStore.prototype, "backgroundColor", null);
    __decorate([
        mobx_1.computed
    ], MainStore.prototype, "isPageDisable", null);
    __decorate([
        mobx_1.action
    ], MainStore.prototype, "setState", void 0);
    __decorate([
        mobx_1.action
    ], MainStore.prototype, "getFrontPlayground", void 0);
    __decorate([
        mobx_1.action
    ], MainStore.prototype, "getFrontModules", void 0);
    return MainStore;
}());
exports.default = MainStore;
